import { useState } from "react";

export const SalesPublish = () => {
    const [tab, setTab] = useState("tab-2");
    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">매출 조회</h3>
                    <div className="filter_toolbar">
                        <button className="btn btn-outline-primary w-100px h-38px"><img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt="" />목록</button>
                        <button className="btn btn-secondary w-100px h-38px">수정</button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label for="" className="form-label frm_label">날짜</label>
                            <select className="form-select">
                                <option>2023</option>
                            </select>
                            <select className="form-select me-0">
                                <option>11</option>
                            </select>
                            <button className="btn btn-info btn_search">
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                            </button>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label for="" className="form-label frm_label">팀/담당자</label>
                            <select className="form-select w-150px">
                                <option>팀</option>
                            </select>
                            <select className="form-select w-140px me-0">
                                <option>담당자</option>
                            </select>
                            <button className="btn btn-info btn_search">
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mybtns_group">
                <div className="btn-group" role="group" aria-label="">
                    <button type="button" className={tab == "tab-1" ? "btn btn-light active" : "btn btn-light"} onClick={() => setTab("tab-1")}>연간매출</button>
                    <button type="button" className={tab == "tab-2" ? "btn btn-light active" : "btn btn-light"} onClick={() => setTab("tab-2")}>고객사 별 매출</button>
                </div>
                <div className="mybtns_group_toolbar">
                    <button className="btn btn-dark w-150px px-0">
                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_export.png"} alt="" />엑셀 내보내기
                    </button>
                </div>
            </div>


            <div className="content_wrap">
                <div className="table_top">
                    <h6 className="table_stats">매출 목록(<span>13</span>건)</h6>
                    <div className="table_toolbar">
                        <button className="btn btn-primary">예상 매출 입력</button>
                        <button className="btn btn-primary color2">새 창에서 보기</button>
                        <button className="btn btn-outline-primary"><img src={process.env.PUBLIC_URL + "/assets/images/icon_gear_blue.png"} alt="" />컬럼설정</button>
                    </div>
                </div>

                <div className="tables_container" style={{ clear: "both" }}>
                    <div className="left" style={{ width: "956px" }}>
                        <table className="table table-bordered my_table my_table_2lines" >
                            <colgroup>
                                <col style={{ width: "7.32%" }} />
                                <col style={{ width: "12.55%" }} />
                                <col style={{ width: "16.73%" }} />
                                <col style={{ width: "16.73%" }} />
                                <col style={{ width: "16.73%" }} />
                                <col style={{ width: "16.73%" }} />
                                <col />
                            </colgroup>
                            <thead>
                                <tr className="h-68px">
                                    <th>
                                        <div className="checkbox_outer">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                            />
                                        </div>
                                    </th>
                                    <th>담당자</th>
                                    <th>고객사</th>
                                    <th>거래처</th>
                                    <th>남품처</th>
                                    <th>벤더</th>
                                    <th className="border-right-1">카테고리</th>
                                </tr>
                            </thead>
                            <tbody>
                                {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((item, index) => (
                                    <tr>
                                        <td className="text-center">
                                            <div className="checkbox_outer">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                />
                                            </div>
                                        </td>
                                        <td className="text-center"><div className="td_lines_2">홍길동</div></td>
                                        <td className="text-center"><div className="td_lines_2">(주)고객사업체</div></td>
                                        <td className="text-center"><div className="td_lines_2">(주)거래처업체</div></td>
                                        <td className="text-center"><div className="td_lines_2">(주) 납품처 업체</div></td>
                                        <td className="text-center"><div className="td_lines_2">MS</div></td>
                                        <td className="text-center border-right-1"><div className="td_lines_2">Win10 ioT</div></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="table_scroll right">
                        {/* Change this calculation according to number of months: width: (num_months * 616) + "px"  */}
                        {/* For example: num_months=12 then width: (12 * 616) + "px" */}
                        <table className="table table-bordered my_table my_table_2lines" style={{ minWidth: "unset", width: (12 * 630) + "px" }}>
                            <thead>
                                <tr>
                                    <th colSpan={3}>1월</th>
                                    <th colSpan={3}>2월</th>
                                    <th colSpan={3}>3월</th>
                                    <th colSpan={3}>4월</th>
                                    <th colSpan={3}>5월</th>
                                    <th colSpan={3}>6월</th>
                                    <th colSpan={3}>7월</th>
                                    <th colSpan={3}>8월</th>
                                    <th colSpan={3}>9월</th>
                                    <th colSpan={3}>10월</th>
                                    <th colSpan={3}>11월</th>
                                    <th colSpan={3}>12월</th>
                                </tr>
                                <tr>
                                    <th>경영 목표</th>
                                    <th>예상 매출</th>
                                    <th>실 매출</th>
                                    <th>경영 목표</th>
                                    <th>예상 매출</th>
                                    <th>실 매출</th>
                                    <th>경영 목표</th>
                                    <th>예상 매출</th>
                                    <th>실 매출</th>
                                    <th>경영 목표</th>
                                    <th>예상 매출</th>
                                    <th>실 매출</th>
                                    <th>경영 목표</th>
                                    <th>예상 매출</th>
                                    <th>실 매출</th>
                                    <th>경영 목표</th>
                                    <th>예상 매출</th>
                                    <th>실 매출</th>
                                    <th>경영 목표</th>
                                    <th>예상 매출</th>
                                    <th>실 매출</th>
                                    <th>경영 목표</th>
                                    <th>예상 매출</th>
                                    <th>실 매출</th>
                                    <th>경영 목표</th>
                                    <th>예상 매출</th>
                                    <th>실 매출</th>
                                    <th>경영 목표</th>
                                    <th>예상 매출</th>
                                    <th>실 매출</th>
                                    <th>경영 목표</th>
                                    <th>예상 매출</th>
                                    <th>실 매출</th>
                                    <th>경영 목표</th>
                                    <th>예상 매출</th>
                                    <th>실 매출</th>
                                </tr>
                            </thead>
                            <tbody>
                                {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((item, index) => (<tr>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">12,345</td>
                                </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="pagination-container">
                    <ul>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
                                alt="First Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
                                alt="Previous Page"
                                className=""
                            />
                        </li>
                        <li className="active">1</li>
                        <li className="">2</li>
                        <li className="">3</li>
                        <li className="">4</li>
                        <li className="">5</li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
                                alt="Next Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
                                alt="Last Page"
                                className=""
                            />
                        </li>
                    </ul>
                </div>
            </div>

        </>
    );
}